import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "../ui/card";

const sections = [
  "GS-1",
  "GS-2",
  "GS-3",
  "GS-4", // This will include both GS-4 and Ethics
  "Extra",
  "Uncategorized",
];

// Define unique colors per section
const sectionStyles = {
  "GS-1": {
    gradient: "from-blue-50 to-indigo-50",
    border: "border-blue-200",
    iconBg: "bg-blue-100",
    iconText: "text-blue-700",
    title: "text-blue-900",
    subtitle: "text-gray-600",
  },
  "GS-2": {
    gradient: "from-green-50 to-emerald-50",
    border: "border-green-200",
    iconBg: "bg-green-100",
    iconText: "text-green-700",
    title: "text-green-900",
    subtitle: "text-gray-600",
  },
  "GS-3": {
    gradient: "from-orange-50 to-yellow-50",
    border: "border-orange-200",
    iconBg: "bg-orange-100",
    iconText: "text-orange-700",
    title: "text-orange-900",
    subtitle: "text-gray-600",
  },
  "GS-4": {
    gradient: "from-purple-50 to-pink-50",
    border: "border-purple-200",
    iconBg: "bg-purple-100",
    iconText: "text-purple-700",
    title: "text-purple-900",
    subtitle: "text-gray-600",
  },
  Extra: {
    gradient: "from-teal-50 to-cyan-50",
    border: "border-teal-200",
    iconBg: "bg-teal-100",
    iconText: "text-teal-700",
    title: "text-teal-900",
    subtitle: "text-gray-600",
  },
  Uncategorized: {
    gradient: "from-gray-50 to-gray-100",
    border: "border-gray-300",
    iconBg: "bg-gray-200",
    iconText: "text-gray-700",
    title: "text-gray-900",
    subtitle: "text-gray-600",
  },
};

const MainsTestSeries = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-4xl mx-auto space-y-6">
      <h1 className="text-3xl font-extrabold text-center text-blue-900 mb-8">
        🗘️ Mains Test Series - Sections
      </h1>

      <div className="grid md:grid-cols-2 gap-6">
        {sections.map((section) => {
          const styles = sectionStyles[section];
          return (
            <Card
              key={section}
              onClick={() => navigate(`/user/tests/mains/${section}`)}
              className={`cursor-pointer group hover:shadow-xl hover:scale-[1.02] 
                          transition-all duration-300 border rounded-2xl 
                          ${styles.border} bg-gradient-to-r ${styles.gradient}`}
            >
              <CardContent className="p-6 flex items-center gap-4">
                {/* Icon */}
                <div
                  className={`flex items-center justify-center w-12 h-12 rounded-xl 
                              ${styles.iconBg} ${styles.iconText} text-2xl 
                              group-hover:scale-110 transition-transform duration-300`}
                >
                  📄
                </div>

                {/* Title + Subtitle */}
                <div className="flex flex-col">
                  <span className={`text-xl font-bold ${styles.title}`}>
                    {section === "GS-4" ? "GS-4 (Ethics)" : section}
                  </span>
                  <span
                    className={`text-sm ${styles.subtitle} group-hover:text-black transition-colors duration-300`}
                  >
                    Click to explore tests & past papers
                  </span>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default MainsTestSeries;
